import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Form, Header, Segment } from 'semantic-ui-react';
import { toast } from 'react-semantic-toasts';
import history from '../../../../utils/history';
import request from '../../../../utils/request';

const { Button, Group, Input } = Form;

class AdminSlidesListView extends React.Component
{
    state = {
        errors: {},
        slide: {},
        image: false,
    };

    /**
     * Mount
     */
    componentDidMount = () => {
        if (this.props.match.params.id) {
            this.fetch();
        }
    }

    /**
     * Fetch
     */
    fetch = () => {
        request(`admin/slides/${this.props.match.params.id}`).then(({ data }) => {
            this.setState({
                slide: data,
            });
        });
    }

    /**
     * Handle input
     */
    handleInput = (e, { name, value }) => {
        const { errors, slide } = this.state;

        this.setState({
            errors: {
                ...errors,
                [name]: false,
            },
            slide: {
                ...slide,
                [name]: value,
            },
        });
    }

    /**
     * Save
     */
    handleSubmit = () => {
        const { id } = this.props.match.params;
        
        const fd = new FormData();
        fd.append('name', this.state.slide.name);
        fd.append('link', this.state.slide.link);
        if (this.state.image) {
            fd.append('image', this.state.image);
        }
        
        request.post(`admin/slides${id ? `/${id}` : ''}`, fd).then(() => {
            toast({
                type: 'success',
                icon: '',
                description: 'Slide saved succesfully',
                time: 2500,
            });
            history.push('/admin/slides');
        }).catch((error) => {
            toast({
                type: 'error',
                icon: '',
                title: 'Something went wrong',
                description: 'Please check all required fields',
                time: 2500,
            });

            this.setState({
                ...this.state,
                errors: error.response.data.errors,
            });
        });
    }

    // --- render
    render() {
        const { errors, slide } = this.state;

        return (
            <Container className="admin-page">
                <Segment padded>
                    <div className="admin-page-header">
                        <Header as="h1">{slide.id ? 'Edit' : 'Create'} slide</Header>
                        <Link to="/admin/slides">Back</Link>
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                        <Input
                            error={errors.name && errors.name !== false}
                            label="Name"
                            name="name"
                            onChange={this.handleInput}
                            required
                            value={slide.name || ''}
                        />
                        <Input
                            label="Link"
                            name="link"
                            onChange={this.handleInput}
                            required
                            placeholder="https://"
                            value={slide.link || ''}
                        />
                        <Input
                            label="Image"
                            name="image"
                            onChange={(e, data) => this.setState({ image: e.target.files[0]})}
                            type="file"
                        />
                        <Group>
                            <Button primary>Save</Button>
                            <Link to="/admin/slides" style={{ marginTop: 9, marginLeft: 10 }}>Cancel</Link>
                        </Group>
                    </Form>
                </Segment>
            </Container>
        );
    }
}

export default AdminSlidesListView;
